import React, { useState, useEffect } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Modal,
  Box
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { RemoveRedEye } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import { askApproveReject, getPrimeAskRejectReason, getPrimeAsksList } from "src/api/commonapi";
import Label from "src/components/Label";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import { Routes } from "src/constant/api_url";
import CustomLoader from "src/components/CustomLoader";

export default function Asks() {
  const askDetailModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const memberActiveType = [
    { label: "All", value: 0 },
    { label: "Active Member", value: 1 },
    { label: "De-Active Member", value: 2 }
  ];

  const askStatus = [
    { label: "All", value: -1 },
    { label: "Open", value: 0 },
    { label: "Fulfill", value: 1 }
  ];
  const askApproveRejectOptions = [
    { label: "All", value: -1 },
    { label: "Approved", value: 0 },
    { label: "Rejected", value: 1 }
  ];

  const [rejectModal, setRejectModal] = useState(false);
  const [confirmApproveModal, setConfirmApproveModal] = useState(false);
  const [selectedAsk, setSelectedAsk] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [searchdata, setsearchdata] = useState({
    activeMemberSearchType: 0,
    asksStatus: -1,
    asksApproveReject: -1,
    searchmember: "",
    startDate: null,
    endDate: null
  });
  const [asksData, setasksData] = useState([]);
  const [newAsksData, setNewAsksData] = useState([]);

  const [askRejectReason, setAskRejectReason] = useState([]);

  const expo_columns = [
    { label: "No", key: "m_id" },
    { label: "Name", key: "m_name" },
    { label: "Business Name", key: "business_name" },
    { label: "Total Meeting", key: "total" },
    { label: "Present", key: "present" },
    { label: "Absent", key: "absent" }
  ];

  const columns = [
    {
      name: "No",
      selector: (row) => row.asks_id,
      wrap: true,
      width: "70px",
      sortable: true
    },
    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row.m_name,
      sortable: true
    },
    {
      name: "Feed Image",
      cell: (row) =>
        row.feed_img ? (
          <a href={`${Routes.API_HOSTNAME}images/asks/${row.feed_img}`} target="_blank">
            <img src={`${Routes.API_HOSTNAME}images/asks/${row.feed_img}`} alt="img" width="100" />
          </a>
        ) : (
          "-"
        ),
      width: "150px"
    },
    {
      name: "Promotion Date",
      wrap: true,
      selector: (row) => row.asks_date,
      sortable: true
    },
    {
      name: "Promotion Status",
      wrap: true,
      selector: (row) => row.asksStatus,
      sortable: true
    },
    {
      name: "Approve/Reject",
      width: "120px",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "5px auto"
          }}
        >
          <Label variant={"ghost"} color={row.ask_approve_reject == 0 ? "success" : "error"}>
            {row.ask_approve_reject == 0 ? "Approve" : "Reject"}
          </Label>
          {loginUser?.u_type != 2 && (
            <Button
              className="bnt-btn-success"
              style={{
                padding: "2px 10px",
                marginTop: "5px",
                color: "white",
                backgroundColor: row.ask_approve_reject != 0 ? "#229A16" : undefined
              }}
              color={row.ask_approve_reject == 0 ? "error" : "success"}
              variant="contained"
              onClick={(e) => {
                setSelectedAsk(row);
                if (row.ask_approve_reject == 0) {
                  setRejectModal(true); // Open reject modal
                } else {
                  setConfirmApproveModal(true); // Open approve confirmation
                }
              }}
            >
              {row.ask_approve_reject == 0 ? "Reject" : " Approve"}
            </Button>
          )}
        </div>
      )
    }
  ];

  const ClearSearchResult = async () => {
    setsearchdata({
      activeMemberSearchType: 0,
      asksStatus: -1,
      asksApproveReject: -1,
      searchmember: "",
      startDate: null,
      endDate: null
    });
  };

  const filterData = () => {
    const parseDate = (str) => {
      if (!str || typeof str !== "string") return null;
      const [dd, mm, yyyy] = str.split("-");
      return new Date(`${yyyy}-${mm}-${dd}`); // Convert to YYYY-MM-DD
    };

    const startDate = parseDate(searchdata.startDate);
    const endDate = parseDate(searchdata.endDate);

    if (startDate) startDate.setHours(0, 0, 0, 0);
    if (endDate) endDate.setHours(0, 0, 0, 0);

    const AsksList =
      asksData &&
      asksData.filter((ask) => {
        let dateMatch = true;
        const askDate = parseDate(ask.asks_date);

        if (startDate && endDate && askDate) {
          // Remove time from comparison
          askDate.setHours(0, 0, 0, 0);
          dateMatch = askDate >= startDate && askDate <= endDate;
        }

        if (
          (searchdata?.activeMemberSearchType == 0
            ? ask.status == 0 || ask.status == 1
            : searchdata?.activeMemberSearchType == 1
              ? ask.status == 1
              : ask.status == 0) &&
          (searchdata?.asksStatus == -1
            ? ask.ask_status == 0 || ask.ask_status == 1
            : searchdata?.asksStatus == 1
              ? ask.ask_status == 1
              : ask.ask_status == 0) &&
          (searchdata?.asksApproveReject == -1
            ? ask.ask_approve_reject == 0 || ask.ask_approve_reject == 1
            : searchdata?.asksApproveReject == 1
              ? ask.ask_approve_reject == 1
              : ask.ask_approve_reject == 0) &&
          dateMatch &&
          (ask.m_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            ask.business_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            ask.business_category.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            ask.mobile_no.toLowerCase().includes(searchdata?.searchmember.toLowerCase()))
        ) {
          return ask;
        }
      });

    setNewAsksData(AsksList);
  };
  // const filterData = () => {
  //   const AsksList =
  //     asksData &&
  //     asksData.filter((ask) => {
  //       const askDate = ask.asks_date ? new Date(ask.asks_date) : null;
  //       const startDate = searchdata.startDate ? new Date(searchdata.startDate) : null;
  //       const endDate = searchdata.endDate ? new Date(searchdata.endDate) : null;

  //       let dateMatch = true;
  //       if (startDate && endDate && askDate) {
  //         // Remove time from comparison
  //         askDate.setHours(0, 0, 0, 0);
  //         startDate.setHours(0, 0, 0, 0);
  //         endDate.setHours(0, 0, 0, 0);
  //         dateMatch = askDate >= startDate && askDate <= endDate;
  //       }

  //       if (
  //         (searchdata?.activeMemberSearchType == 0
  //           ? ask.status == 0 || ask.status == 1
  //           : searchdata?.activeMemberSearchType == 1
  //           ? ask.status == 1
  //           : ask.status == 0) &&
  //         (searchdata?.asksStatus == -1
  //           ? ask.ask_status == 0 || ask.ask_status == 1
  //           : searchdata?.asksStatus == 1
  //           ? ask.ask_status == 1
  //           : ask.ask_status == 0) &&
  //         (searchdata?.asksApproveReject == -1
  //           ? ask.ask_approve_reject == 0 || ask.ask_approve_reject == 1
  //           : searchdata?.asksApproveReject == 1
  //           ? ask.ask_approve_reject == 1
  //           : ask.ask_approve_reject == 0) &&
  //         dateMatch &&
  //         (ask.m_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
  //           ask.business_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
  //           ask.business_category.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
  //           ask.mobile_no.toLowerCase().includes(searchdata?.searchmember.toLowerCase()))
  //       ) {
  //         return ask;
  //       }
  //     });

  //   setNewAsksData(AsksList);
  // };

  useEffect(() => {
    filterData();
  }, [searchdata, asksData]);

  const GetAsksData = async () => {
    setIsLoading(true);
    let res = await getPrimeAsksList();
    setIsLoading(false);
    if (res?.data?.length > 0) {
      setasksData(res?.data);
    } else {
      setasksData([]);
    }
  };
  useEffect(async () => {
    GetAsksData();
    getAskRejectReasonData();
  }, []);

  const getAskRejectReasonData = async () => {
    let res = await getPrimeAskRejectReason();
    setAskRejectReason(res);
  };

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.feed_desc != null && data?.feed_desc != "" && (
          <p>
            <b>Feed Description</b> : {data?.feed_desc}
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <Page title="Promotion | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Promotion
            </Typography>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Stack spacing={0}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={enGB}
                    style={{ marginTop: "0px" }}
                  >
                    <label>Select Promotion Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata.startDate
                          ? new Date(searchdata.startDate.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                          : null
                      }
                      onChange={(newDate) => {
                        if (newDate instanceof Date && !isNaN(newDate)) {
                          const day = String(newDate.getDate()).padStart(2, "0");
                          const month = String(newDate.getMonth() + 1).padStart(2, "0");
                          const year = newDate.getFullYear();
                          setsearchdata({
                            ...searchdata,
                            startDate: `${day}-${month}-${year}`
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={0}>
                  <label>Select Promotion End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata.endDate
                          ? new Date(searchdata.endDate.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                          : null
                      }
                      onChange={(newDate) => {
                        if (newDate instanceof Date && !isNaN(newDate)) {
                          const day = String(newDate.getDate()).padStart(2, "0");
                          const month = String(newDate.getMonth() + 1).padStart(2, "0");
                          const year = newDate.getFullYear();
                          setsearchdata({
                            ...searchdata,
                            endDate: `${day}-${month}-${year}`
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={3}>
                  <label>Search Member</label>
                  <TextField
                    style={{ marginTop: "0px" }}
                    autoComplete="off"
                    type="text"
                    label="Search Member"
                    name="search"
                    value={searchdata?.searchmember ? searchdata?.searchmember : ""}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        searchmember: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Member Active Type</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        if (option.value == searchdata.activeMemberSearchType) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, activeMemberSearchType: e.value });
                    }}
                    options={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Promotion Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      askStatus &&
                      askStatus.map((option) => {
                        if (option.value == searchdata.asksStatus) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, asksStatus: e.value });
                    }}
                    options={
                      askStatus &&
                      askStatus.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Promotion Approve/Reject</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      askApproveRejectOptions &&
                      askApproveRejectOptions.map((option) => {
                        if (option.value == searchdata.asksApproveReject) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, asksApproveReject: e.value });
                    }}
                    options={
                      askApproveRejectOptions &&
                      askApproveRejectOptions.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid
                xs={3}
                item
                sx={{ display: "flex", justifyContent: "flex-center", alignItems: "center" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card style={{ marginTop: "15px" }}>
            {asksData && (
              <>
                {/* <Button className="btn btn-export">
                  <CSVLink
                    data={asksData}
                    headers={expo_columns}
                    filename={"Asks.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button> */}
                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={newAsksData != null ? newAsksData : []}
                  expandableRows
                  expandableRowsComponent={ExpandableRow}
                  expandableRowDisabled={(row) => !row?.feed_desc}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>

        {/* Reject Reason Modal */}
        <Modal open={rejectModal} onClose={() => setRejectModal(false)}>
          <Box sx={askDetailModalStyle}>
            <Typography variant="h6" textAlign="center">
              Reject Reason
            </Typography>
            <Select
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 1300 })
              }}
              onChange={(e) => {
                setRejectReason(e.value);
              }}
              options={askRejectReason?.map((reasons) => ({
                label: reasons?.ask_reject_reason,
                value: reasons?.a_r_reason_id
              }))}
            />
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="error"
                onClick={async () => {
                  if (!rejectReason) {
                    notification({
                      type: "error",
                      message: "Please select a reject reason."
                    })();
                    return;
                  }

                  const res = await askApproveReject({
                    asks_id: selectedAsk?.asks_id,
                    ask_approve_reject: 1,
                    rejected_reason: rejectReason
                  });

                  if (res.status == 1) {
                    let notify = notification({
                      type: res.status == 0 ? "error" : "success",
                      message: res.message
                    });
                    notify();
                    GetAsksData(); // refresh data
                  }
                  setRejectModal(false);
                  setRejectReason("");
                }}
              >
                Submit
              </Button>
              <Button variant="outlined" onClick={() => setRejectModal(false)}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* Approve Confirmation Modal */}
        <Modal open={confirmApproveModal} onClose={() => setConfirmApproveModal(false)}>
          <Box sx={askDetailModalStyle}>
            <Typography variant="h6" textAlign="center">
              Are you sure you want to approve this ask?
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                className="btn btn-primary"
                onClick={async () => {
                  const res = await askApproveReject({
                    asks_id: selectedAsk?.asks_id,
                    ask_approve_reject: 0
                  }); // 0 = approve
                  if (res.status == 1) {
                    let notify = notification({
                      type: res.status == 0 ? "error" : "success",
                      message: res.message
                    });
                    notify();
                    GetAsksData(); // refresh data
                  }
                  setConfirmApproveModal(false);
                }}
              >
                Yes, Approve
              </Button>
              <Button variant="outlined" onClick={() => setConfirmApproveModal(false)}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
